import { useContext } from "react";

import { analyticsContext } from "../contexts/analytics";

export const useAnalytics = () => useContext(analyticsContext);
